import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { BackendService } from '../core/services/backend-prod.service';
import { HelperService } from '../core/services/helper.service';
import { Storage } from '@ionic/storage';
import { MenuService } from '../core/services/menu.service';

@Component({
  selector: 'app-config',
  templateUrl: './config.page.html',
  styleUrls: ['./config.page.scss'],
})
export class ConfigPage implements OnInit {

  breadcrumbList = [
    {
      label: 'System Config',
      embedurl: true,
      url: '/baseapp/config'
    },
  ];

  configDisplayedColumns: string[] = ['config_name', 'action'];
  configDataSource: any;
  updateConfigApi: any;
  hide1200 = false;
  loading = true;
  bubbleshow: boolean = false;

  constructor(
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public menuService: MenuService,
    public alertController: AlertController,
    public helperService: HelperService
    ) { }

  ngOnInit() {
    this.getAllConfig();
    // this.helperService.loader();
  }

  getAllConfig() {
    // this.helperService.loader();
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getConfig', res.token).subscribe(
        (data) => {
          let configDataSource = [];
          configDataSource.push(data);
          
          for (let item of configDataSource) {
            if(item.config_value == "0") {
              item.config_value = true
            } else {
              item.config_value = false
            }
          }
          this.configDataSource = configDataSource;
          // this.helperService.closeLoader();
        },
        (error) => {
          //console.log(error);
          this.loading = false;
          // this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    });
  }

  configToggle(config_value, userId) {
    this.getStorage().then((res) => {
      // Convert the boolean event value to a string "1" or "0"
      const configValue = config_value ? "0" : "1";
      let payload = {
        id: userId,
        // config_name: configName,
        config_value: configValue,
      };
      this.updateConfigApi = this.backendService.PutAPICall('updateConfig', payload, res.token).subscribe(
        (data) => {
          this.helperService.presentToast(data.msg, 2000);
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    });
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }
}
